import { faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Fab, Modal } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useUpdateGroupGradeMutation } from '../finalGradeApiSlice';
const GroupGradeUpdateForm = ({currentGroupGrade, showUpdateModal, setShowUpdateModal}) => {
  const [blocked, setBlocked] = useState(currentGroupGrade?.blocked)
  const [total, setTotal] = useState(currentGroupGrade?.total || 0)
  const [comments, setComments] = useState(currentGroupGrade?.comments || "")
  useEffect(()=>{
    if(currentGroupGrade){
      setBlocked(currentGroupGrade.blocked)
      setTotal(currentGroupGrade.total)
      setComments(currentGroupGrade.comments)
    }
  },[currentGroupGrade])

  const [updateGroupGrade, {
    isLoading,
    isSuccess,
    isError,
    error
}] = useUpdateGroupGradeMutation()
const updateButtonClicked = async ()=>{
 await updateGroupGrade({id:currentGroupGrade._id, total, blocked, comments})
 setShowUpdateModal(false)
}
    const navigate = useNavigate()
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        color:'black',
        transform: 'translate(-50%, -50%)',
        minWidth: '80%',
        minHeight: '70%',
        maxHeight: '80%',
        overflowY:'auto',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
      };
    const handleClose = () => {
        setShowUpdateModal(false)
      };
      if(!currentGroupGrade) return <></>
  return (
    <Modal
  open={showUpdateModal}
  onClose={handleClose}
  aria-labelledby="parent-modal-title"
  aria-describedby="parent-modal-description"
  disableScrollLock={true}
>
    
  <Box id="modal-grades" sx={{ ...style }}>
    <div className='modal-header'>
     <div className='modal-header-text'>
     <h2 >{currentGroupGrade.username}  {currentGroupGrade.fullname} </h2>
    <h3 > ציון סופי : {currentGroupGrade.total?.toFixed(2)}</h3>
     </div>
     <div className='modal-header-actions'>
    
    
 <Fab onClick={handleClose} variant="extended">
            <FontAwesomeIcon icon={faTimes} />
</Fab>
     </div>
    
    </div>

    <label className="form__label" htmlFor="total">
                    Total:</label>
                   
                <input
                    className={`form__input  ${!total &&'form__input--incomplete'}`}
                    id="total"
                    name="total"
                    type="text"
                    autoComplete="off"
                    value={total}
                    onChange={(e)=>setTotal(e.target.value)}
                />
                <div className="form-input-container">

    <label className="form__label" htmlFor="comments">
                    Comments:</label>
                   
                <input
                    className={`form__input`}
                    id="comments"
                    name="comments"
                    type="text"
                    autoComplete="off"
                    value={comments}
                    onChange={(e)=>setComments(e.target.value)}
                />
                </div>

<div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="blocked">
                    Blocked:
                    <input
                        className="form__checkbox"
                        id="blocked"
                        name="blocked"
                        type="checkbox"
                        checked={blocked}
                        onChange={(e)=>setBlocked(prev => !prev)}
                    />
                </label>
                אם מוגדר כחסום אם יחוללו הציונים שוב והציון האוטומטי יהיה גבוה ממה שניתן הוא לא יעודכן
               
                    </div>
                
                </div>
   
 
                <Button variant="contained" onClick={updateButtonClicked}>Save</Button>

           
  </Box>
</Modal>
  )
}

export default GroupGradeUpdateForm